/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates the direction a column should be sorted in.
 */
export var ColumnSortDirection = /*@__PURE__*/ (function (ColumnSortDirection) {
    /**
     * Not sort applied.
     */
    ColumnSortDirection[ColumnSortDirection["None"] = 0] = "None";
    /**
     * Sort is ascending.
     */
    ColumnSortDirection[ColumnSortDirection["Ascending"] = 1] = "Ascending";
    /**
     * Sort is descending.
     */
    ColumnSortDirection[ColumnSortDirection["Descending"] = 2] = "Descending";
    return ColumnSortDirection;
})({});
/**
 * @hidden
 */
export var ColumnSortDirection_$type = /*@__PURE__*/ markEnum('ColumnSortDirection', 'None,0|Ascending,1|Descending,2');
//# sourceMappingURL=ColumnSortDirection.js.map
